// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.f1rOEdndfPtVVc9u_fmz {
    display: flex;
    flex-direction: column;
    gap: 1.2rem;
    min-width: 0;
}
.f1rOEdndfPtVVc9u_fmz p {
    margin: 0;
    line-height: 1.6;
}

.aYkjvK_4CiuuoxZwzGWP {
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
    min-width: 0;
}
.lhnF2L0vEj7Yz4QUXMmj {
    display: grid;
    align-items: end;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 1.2rem;
    border: 0;
    padding: 0;
    margin: 0;
    min-width: 0;
}
.b3p8Lcr4ik_LkeXDTKGW {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1.25fr);
    gap: 1.2rem;
    min-width: 0;
}
.b3p8Lcr4ik_LkeXDTKGW.iqGKconwFQ29HP9qF9DH {
    grid-template-columns: minmax(0, 1fr);
}
.dHfcCWxdRxirJbaeAABq[hidden] {
    display: none;
}
.dHfcCWxdRxirJbaeAABq,
.qDADZPFzURF4acl9s4pj {
    display: flex;
    flex-direction: column;
    gap: 1.2rem;
    min-width: 0;
}
.ik_Vocfs_ig_kI6M1lAi,
.KIAgy7ez19pSHUScjdli,
.hC2pAvJn1nz3WYTadFHl {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 1.2rem;
}
.ik_Vocfs_ig_kI6M1lAi {
    min-height: 3.6rem;
}
.JRo4oFExU_pT6i4BPrBa {
    display: grid;
    grid-template-columns: max-content minmax(0, 1fr);
    grid-template-rows: minmax(0, 1fr);
    width: 100%;
    min-width: 0;
    min-height: 64rem;
    height: 64rem;
    box-sizing: border-box;
    border: 1px solid var(--mark-border);
    color: var(--mark-text);
    background: var(--mark-surface);
    border-radius: 0.8rem;
    resize: vertical;
    overflow: hidden;
    /* Keep the fixed height; growing would size the box to the full gutter and stop scrolling. */
    flex: none;
}
.q8FMNzPNNj4l3gBZBj6A,
.HNljBMgtwn6IBHz5Nqcc {
    font: 1.4rem/1.7 monospace;
    padding: 1.6rem;
    box-sizing: border-box;
    min-height: 0;
    white-space: pre;
}
.q8FMNzPNNj4l3gBZBj6A {
    min-width: 0;
    width: 100%;
    height: 100%;
    margin: 0;
    border: 0;
    outline: none;
    color: var(--mark-text);
    background: var(--mark-surface);
    resize: none;
    overflow: auto;
    tab-size: 4;
}
.HNljBMgtwn6IBHz5Nqcc {
    min-width: calc(4ch + 3.2rem + 1px);
    color: var(--mark-muted);
    border-right: 1px solid var(--mark-border);
    text-align: right;
    overflow: hidden;
    user-select: none;
}
.HNljBMgtwn6IBHz5Nqcc::after {
    content: '';
    display: block;
    /* Allow scrolling to follow a textarea whose horizontal scrollbar reduces its viewport. */
    height: 100%;
}
.JRo4oFExU_pT6i4BPrBa:focus-within,
.NMPbKGaQSBwCDX5TSnVE summary:focus-visible {
    outline: 2px solid var(--mark-primary);
    outline-offset: 3px;
}
.MODzYUWA4nFDhu0PNhA4 {
    color: var(--mark-muted);
    font-size: 1.4rem;
    line-height: 1.6;
    overflow-wrap: anywhere;
}

.DerOVDRIj6E3aogAzpL3 {
    display: flex;
    justify-content: center;
    min-height: 64rem;
    border: 1px solid var(--mark-border);
    border-radius: 0.8rem;
    overflow: hidden;
    padding: 0.6rem;
    background: var(--mark-border);
}
.Tskakx1enAc11ZP8hucX {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.8rem;
    padding: 2.4rem;
    text-align: center;
    color: var(--mark-muted);
}
._LGRj0DXMtkr7JhpxrvZ {
    padding: 1.6rem 2rem;
    border-left: 3px solid var(--mark-primary);
    background: var(--mark-selected);
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
}
.R_X79pknD8alX32nggkN {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 1.2rem;
    margin-top: 0.8rem;
}
.R_X79pknD8alX32nggkN code {
    overflow-wrap: anywhere;
    min-width: 0;
    font-size: 1.3rem;
}
.NMPbKGaQSBwCDX5TSnVE {
    border-top: 1px solid var(--mark-border);
    border-bottom: 1px solid var(--mark-border);
    padding: 0.8rem 0;
}
.NMPbKGaQSBwCDX5TSnVE summary {
    cursor: pointer;
    font-weight: 600;
    padding: 0.4rem 0;
}
.NMPbKGaQSBwCDX5TSnVE aside {
    display: flex;
    flex-direction: column;
    gap: 1.6rem;
    margin-top: 1.6rem;
}
.WWIQcFy44bi4_fahE8LN {
    display: flex;
    flex-wrap: wrap;
    gap: 0.8rem;
}
.hC2pAvJn1nz3WYTadFHl {
    background: var(--mark-surface);
    padding-bottom: 0.8rem;
    padding-top: 0.8rem;
    border-top: 1px solid var(--mark-border);
}
.hC2pAvJn1nz3WYTadFHl > div {
    flex: 1;
    min-width: min(100%, 24rem);
}
.WcvOSYRFNeFKiBPotGp4 {
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
    background: var(--mark-danger-surface);
    color: var(--mark-danger);
    border-radius: 0.8rem;
    padding: 1.6rem;
    overflow-wrap: anywhere;
}
@media (max-width: 1000px) {
    .b3p8Lcr4ik_LkeXDTKGW {
        grid-template-columns: minmax(0, 1fr);
    }
    .JRo4oFExU_pT6i4BPrBa {
        min-height: 32rem;
    }
}
@media (max-width: 600px) {
    .lhnF2L0vEj7Yz4QUXMmj {
        grid-template-columns: minmax(0, 1fr);
        gap: 1.6rem;
    }
    .DerOVDRIj6E3aogAzpL3 {
        padding: 0.4rem;
    }
    ._LGRj0DXMtkr7JhpxrvZ {
        padding: 1.6rem;
    }
}

._r_gqr4zNRf2jRxy4FFd {
    border-bottom: 1px solid var(--mark-border);
    padding-bottom: 0.8rem;
    min-width: 0;
}
._r_gqr4zNRf2jRxy4FFd summary {
    cursor: pointer;
    padding: 0.6rem 0;
    font-size: 1.4rem;
    line-height: 2rem;
    overflow-wrap: anywhere;
}
._r_gqr4zNRf2jRxy4FFd summary:focus-visible {
    outline: 2px solid var(--mark-primary);
    outline-offset: 2px;
}
.T5p9eHxLEFmm9PRisjOa {
    color: var(--mark-muted);
    margin-left: 1.2rem;
    font-weight: 400;
}
._r_gqr4zNRf2jRxy4FFd .lhnF2L0vEj7Yz4QUXMmj {
    margin-top: 0.8rem;
    gap: 1.2rem;
}
.WCJp8y39nh2OcGD0LvyK {
    grid-template-columns: repeat(3, minmax(0, 1fr));
}
@media (max-width: 700px) {
    .WCJp8y39nh2OcGD0LvyK {
        grid-template-columns: minmax(0, 1fr);
    }
}
`, "",{"version":3,"sources":["webpack://./pages/Mark/components/htmlTemplateEditor.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,YAAY;AAChB;AACA;IACI,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,YAAY;AAChB;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,gDAAgD;IAChD,WAAW;IACX,SAAS;IACT,UAAU;IACV,SAAS;IACT,YAAY;AAChB;AACA;IACI,aAAa;IACb,uDAAuD;IACvD,WAAW;IACX,YAAY;AAChB;AACA;IACI,qCAAqC;AACzC;AACA;IACI,aAAa;AACjB;AACA;;IAEI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,YAAY;AAChB;AACA;;;IAGI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,WAAW;AACf;AACA;IACI,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,iDAAiD;IACjD,kCAAkC;IAClC,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,oCAAoC;IACpC,uBAAuB;IACvB,+BAA+B;IAC/B,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;IAChB,6FAA6F;IAC7F,UAAU;AACd;AACA;;IAEI,0BAA0B;IAC1B,eAAe;IACf,sBAAsB;IACtB,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,SAAS;IACT,SAAS;IACT,aAAa;IACb,uBAAuB;IACvB,+BAA+B;IAC/B,YAAY;IACZ,cAAc;IACd,WAAW;AACf;AACA;IACI,mCAAmC;IACnC,wBAAwB;IACxB,0CAA0C;IAC1C,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,cAAc;IACd,0FAA0F;IAC1F,YAAY;AAChB;AACA;;IAEI,sCAAsC;IACtC,mBAAmB;AACvB;AACA;IACI,wBAAwB;IACxB,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,iBAAiB;IACjB,oCAAoC;IACpC,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,8BAA8B;AAClC;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,wBAAwB;AAC5B;AACA;IACI,oBAAoB;IACpB,0CAA0C;IAC1C,gCAAgC;IAChC,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;AACA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,uBAAuB;IACvB,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,wCAAwC;IACxC,2CAA2C;IAC3C,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,eAAe;IACf,WAAW;AACf;AACA;IACI,+BAA+B;IAC/B,sBAAsB;IACtB,mBAAmB;IACnB,wCAAwC;AAC5C;AACA;IACI,OAAO;IACP,2BAA2B;AAC/B;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,sCAAsC;IACtC,yBAAyB;IACzB,qBAAqB;IACrB,eAAe;IACf,uBAAuB;AAC3B;AACA;IACI;QACI,qCAAqC;IACzC;IACA;QACI,iBAAiB;IACrB;AACJ;AACA;IACI;QACI,qCAAqC;QACrC,WAAW;IACf;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,2CAA2C;IAC3C,sBAAsB;IACtB,YAAY;AAChB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;IACjB,uBAAuB;AAC3B;AACA;IACI,sCAAsC;IACtC,mBAAmB;AACvB;AACA;IACI,wBAAwB;IACxB,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,gDAAgD;AACpD;AACA;IACI;QACI,qCAAqC;IACzC;AACJ","sourcesContent":[".editor {\n    display: flex;\n    flex-direction: column;\n    gap: 1.2rem;\n    min-width: 0;\n}\n.editor p {\n    margin: 0;\n    line-height: 1.6;\n}\n\n.field {\n    display: flex;\n    flex-direction: column;\n    gap: 0.8rem;\n    min-width: 0;\n}\n.fields {\n    display: grid;\n    align-items: end;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 1.2rem;\n    border: 0;\n    padding: 0;\n    margin: 0;\n    min-width: 0;\n}\n.split {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) minmax(0, 1.25fr);\n    gap: 1.2rem;\n    min-width: 0;\n}\n.split.expanded {\n    grid-template-columns: minmax(0, 1fr);\n}\n.source[hidden] {\n    display: none;\n}\n.source,\n.previewPanel {\n    display: flex;\n    flex-direction: column;\n    gap: 1.2rem;\n    min-width: 0;\n}\n.panelHeader,\n.actions,\n.footer {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    gap: 1.2rem;\n}\n.panelHeader {\n    min-height: 3.6rem;\n}\n.codeEditor {\n    display: grid;\n    grid-template-columns: max-content minmax(0, 1fr);\n    grid-template-rows: minmax(0, 1fr);\n    width: 100%;\n    min-width: 0;\n    min-height: 64rem;\n    height: 64rem;\n    box-sizing: border-box;\n    border: 1px solid var(--mark-border);\n    color: var(--mark-text);\n    background: var(--mark-surface);\n    border-radius: 0.8rem;\n    resize: vertical;\n    overflow: hidden;\n    /* Keep the fixed height; growing would size the box to the full gutter and stop scrolling. */\n    flex: none;\n}\n.code,\n.lineNumbers {\n    font: 1.4rem/1.7 monospace;\n    padding: 1.6rem;\n    box-sizing: border-box;\n    min-height: 0;\n    white-space: pre;\n}\n.code {\n    min-width: 0;\n    width: 100%;\n    height: 100%;\n    margin: 0;\n    border: 0;\n    outline: none;\n    color: var(--mark-text);\n    background: var(--mark-surface);\n    resize: none;\n    overflow: auto;\n    tab-size: 4;\n}\n.lineNumbers {\n    min-width: calc(4ch + 3.2rem + 1px);\n    color: var(--mark-muted);\n    border-right: 1px solid var(--mark-border);\n    text-align: right;\n    overflow: hidden;\n    user-select: none;\n}\n.lineNumbers::after {\n    content: '';\n    display: block;\n    /* Allow scrolling to follow a textarea whose horizontal scrollbar reduces its viewport. */\n    height: 100%;\n}\n.codeEditor:focus-within,\n.tools summary:focus-visible {\n    outline: 2px solid var(--mark-primary);\n    outline-offset: 3px;\n}\n.hint {\n    color: var(--mark-muted);\n    font-size: 1.4rem;\n    line-height: 1.6;\n    overflow-wrap: anywhere;\n}\n\n.previewCanvas {\n    display: flex;\n    justify-content: center;\n    min-height: 64rem;\n    border: 1px solid var(--mark-border);\n    border-radius: 0.8rem;\n    overflow: hidden;\n    padding: 0.6rem;\n    background: var(--mark-border);\n}\n.previewEmpty {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 0.8rem;\n    padding: 2.4rem;\n    text-align: center;\n    color: var(--mark-muted);\n}\n.guidance {\n    padding: 1.6rem 2rem;\n    border-left: 3px solid var(--mark-primary);\n    background: var(--mark-selected);\n    display: flex;\n    flex-direction: column;\n    gap: 0.8rem;\n}\n.example {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n    gap: 1.2rem;\n    margin-top: 0.8rem;\n}\n.example code {\n    overflow-wrap: anywhere;\n    min-width: 0;\n    font-size: 1.3rem;\n}\n.tools {\n    border-top: 1px solid var(--mark-border);\n    border-bottom: 1px solid var(--mark-border);\n    padding: 0.8rem 0;\n}\n.tools summary {\n    cursor: pointer;\n    font-weight: 600;\n    padding: 0.4rem 0;\n}\n.tools aside {\n    display: flex;\n    flex-direction: column;\n    gap: 1.6rem;\n    margin-top: 1.6rem;\n}\n.variables {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.8rem;\n}\n.footer {\n    background: var(--mark-surface);\n    padding-bottom: 0.8rem;\n    padding-top: 0.8rem;\n    border-top: 1px solid var(--mark-border);\n}\n.footer > div {\n    flex: 1;\n    min-width: min(100%, 24rem);\n}\n.error {\n    display: flex;\n    flex-direction: column;\n    gap: 0.8rem;\n    background: var(--mark-danger-surface);\n    color: var(--mark-danger);\n    border-radius: 0.8rem;\n    padding: 1.6rem;\n    overflow-wrap: anywhere;\n}\n@media (max-width: 1000px) {\n    .split {\n        grid-template-columns: minmax(0, 1fr);\n    }\n    .codeEditor {\n        min-height: 32rem;\n    }\n}\n@media (max-width: 600px) {\n    .fields {\n        grid-template-columns: minmax(0, 1fr);\n        gap: 1.6rem;\n    }\n    .previewCanvas {\n        padding: 0.4rem;\n    }\n    .guidance {\n        padding: 1.6rem;\n    }\n}\n\n.settings {\n    border-bottom: 1px solid var(--mark-border);\n    padding-bottom: 0.8rem;\n    min-width: 0;\n}\n.settings summary {\n    cursor: pointer;\n    padding: 0.6rem 0;\n    font-size: 1.4rem;\n    line-height: 2rem;\n    overflow-wrap: anywhere;\n}\n.settings summary:focus-visible {\n    outline: 2px solid var(--mark-primary);\n    outline-offset: 2px;\n}\n.settingsSummary {\n    color: var(--mark-muted);\n    margin-left: 1.2rem;\n    font-weight: 400;\n}\n.settings .fields {\n    margin-top: 0.8rem;\n    gap: 1.2rem;\n}\n.libraryFields {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n@media (max-width: 700px) {\n    .libraryFields {\n        grid-template-columns: minmax(0, 1fr);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export var editor = `f1rOEdndfPtVVc9u_fmz`;
export var field = `aYkjvK_4CiuuoxZwzGWP`;
export var fields = `lhnF2L0vEj7Yz4QUXMmj`;
export var split = `b3p8Lcr4ik_LkeXDTKGW`;
export var expanded = `iqGKconwFQ29HP9qF9DH`;
export var source = `dHfcCWxdRxirJbaeAABq`;
export var previewPanel = `qDADZPFzURF4acl9s4pj`;
export var panelHeader = `ik_Vocfs_ig_kI6M1lAi`;
export var actions = `KIAgy7ez19pSHUScjdli`;
export var footer = `hC2pAvJn1nz3WYTadFHl`;
export var codeEditor = `JRo4oFExU_pT6i4BPrBa`;
export var code = `q8FMNzPNNj4l3gBZBj6A`;
export var lineNumbers = `HNljBMgtwn6IBHz5Nqcc`;
export var tools = `NMPbKGaQSBwCDX5TSnVE`;
export var hint = `MODzYUWA4nFDhu0PNhA4`;
export var previewCanvas = `DerOVDRIj6E3aogAzpL3`;
export var previewEmpty = `Tskakx1enAc11ZP8hucX`;
export var guidance = `_LGRj0DXMtkr7JhpxrvZ`;
export var example = `R_X79pknD8alX32nggkN`;
export var variables = `WWIQcFy44bi4_fahE8LN`;
export var error = `WcvOSYRFNeFKiBPotGp4`;
export var settings = `_r_gqr4zNRf2jRxy4FFd`;
export var settingsSummary = `T5p9eHxLEFmm9PRisjOa`;
export var libraryFields = `WCJp8y39nh2OcGD0LvyK`;
export default ___CSS_LOADER_EXPORT___;
